document.addEventListener("DOMContentLoaded", function () {
  initializeSliders();
  
  // Add this function to initialize sliders
  function initializeSliders() {
    const sliders = document.querySelectorAll("slider-component");
    
    sliders.forEach((slider) => {
      const sliderContainer = slider.querySelector(".mr-slider");
      const prevButton = slider.querySelector(".slider-button--prev");
      const nextButton = slider.querySelector(".slider-button--next");
      
      if (!sliderContainer || !prevButton || !nextButton) return;
      
      // Setup click handlers
      prevButton.addEventListener("click", () => {
        // Add scroll behavior
        const itemWidth = sliderContainer.querySelector(".mr-slider-slide").offsetWidth;
        sliderContainer.scrollBy({
          left: -itemWidth,
          behavior: "smooth"
        });
      });
      
      nextButton.addEventListener("click", () => {
        // Add scroll behavior
        const itemWidth = sliderContainer.querySelector(".mr-slider-slide").offsetWidth;
        sliderContainer.scrollBy({
          left: itemWidth,
          behavior: "smooth"
        });
      });
      
      const updateButtonsState = () => {
        const containerWidth = sliderContainer.offsetWidth;
        const maxScrollLeft = sliderContainer.scrollWidth - containerWidth;
        const scrollLeft = sliderContainer.scrollLeft;
        
        // Disable prevButton if at the start
        if (scrollLeft <= 5) { // Small tolerance for rounding errors
          prevButton.setAttribute("disabled", "disabled");
        } else {
          prevButton.removeAttribute("disabled");
        }
        
        // Disable nextButton if at the end
        if (scrollLeft >= maxScrollLeft - 5) { // Small tolerance for rounding errors
          nextButton.setAttribute("disabled", "disabled");
        } else {
          nextButton.removeAttribute("disabled");
        }
      };
      
      // Initial update to set the buttons' states
      updateButtonsState();
      
      // Recalculate dimensions and update button states on window resize
      window.addEventListener("resize", () => {
        updateButtonsState();
      });
      
      // Update buttons' states on manual scrolling
      sliderContainer.addEventListener("scroll", updateButtonsState);
    });
  }
  
  // Consider adding a MutationObserver to handle dynamically loaded content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initializeSliders();
      }
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});